/**
 * Created by rhinov15 on 30/04/2019.
 */

import { ActionState, ActionStateEnum , FrontViewAddArea, FrontViewCutArea, FrontViewAddEntity, FrontViewCoating, FrontViewAddJoinery} from "..";
import { FrontViewManager } from "../../plan/FrontViewManager";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { GUIConstants } from "../../utils/GUIConstants";
import { EntityManager } from "../../plan/EntityManager";

import { PlanManager } from "../../../../cocosPlan";
import { AddArea, ArrangementGroup, ArrangementObject, Canopy, CeilingBox, CoatingArea, Commands, ComponentConstants, CutArea, Door, Entity, EntityDefaultPropertiesManager, EntityFactory, Event, Events, eventsManager, Joinery, joineryManager, JoineryType, Listener, math, Niche, roomManager, SavaneConstants, SavaneMath, SceneConstants, TechnicalElement, Velux, Wall, wallManager, Window } from "@rhinov/savane-js";

/**
 *
 * Global state to manage the 2D cocos front view where we can move joineries
 *
 */

declare var cc: any;


export class FrontViewState extends ActionState {

    deleteListener: Listener | null = null;
    ungroupEntitiesListener: Listener | null = null;
    ungroupEntityListener: Listener | null = null;
    unselectListener: Listener | null = null;
    plusListener: Listener | null = null;
    lessListener: Listener | null = null;
    sliderListener: Listener | null = null;
    textFieldListener: Listener | null = null;
    actionCountChange: Listener | null = null;
    changeEditorSelectionListener: Listener | null = null;
    // Store state name from global enum
    state = ActionStateEnum.FrontView;
    _resizingHeight: boolean = false;
    _resizingRight: boolean = false;
    hasBeenEdited: boolean = false;
    entityEdition: Listener;

    // Edited entity (none at start)
    _entity: Entity | null = null;
    // Are we dragging the edited entity
    _isDragging: boolean = false;
    // Are we resizing the edited entity
    _isResizing: any = false;
    // Mouse cursor last position
    _lastPosition: math.vec3 | null = null;
    // Mouse cursor current position
    _cursorPosition: math.vec3 | null = null;
    // shift isn't pressed
    shiftPressed: boolean = false;
    _previousStateWasConstruction: boolean;
    _addCoatingListener: Listener | null = null;
    _addArrangementListener: Listener | null = null;
    _flipViewListener: Listener | null = null;
    _hideArrangements: Listener | null = null;

    constructor(previousStateWasConstruction?: boolean) {
        super();
        this.deleteListener = eventsManager.instance.addListener(Events.DELETE_EVENT, this.actionDelete.bind(this));
        this.ungroupEntitiesListener = eventsManager.instance.addListener(Events.UNGROUP_ENTITIES, this.actionUngroup);
        this.ungroupEntityListener = eventsManager.instance.addListener(Events.UNGROUP_ENTITY, this.actionLeaveGroup);
        this.unselectListener = eventsManager.instance.addListener(Events.UNSELECT_PRESSED, this.actionEditEnded.bind(this));
        this.plusListener = eventsManager.instance.addListener(Events.PLUS_CLICKED, this.plusOrLessClickedHandler.bind(this));
        this.lessListener = eventsManager.instance.addListener(Events.LESS_CLICKED, this.plusOrLessClickedHandler.bind(this));
        this.sliderListener = eventsManager.instance.addListener(Events.SLIDER_BUTTON, this.sliderButtonHandler.bind(this));
        this.textFieldListener = eventsManager.instance.addListener(Events.TEXTFIELD_EDIT_ENDED, (event: any) => {
            this.actionTextFieldEditEnded(event.getUserData().editedProperty, event.getUserData().value, event.getUserData().obj);
        });
        this.actionCountChange = eventsManager.instance.addListener(Events.COMMAND_EXECUTED, (event: any) => {
            switch (event.userData.name) {
                case Commands.CommandEnum.EditComponentCommand:
                case Commands.CommandEnum.DeleteComponentCommand:
                case Commands.CommandEnum.DeleteTechnicalElementCommand:
                case Commands.CommandEnum.DeleteJoineriesCommand:
                case Commands.CommandEnum.AddJoineryCommand:
                case Commands.CommandEnum.AddEntityCommand:
                case Commands.CommandEnum.DeleteEntityCommand:
                    PlanManager.getInstance().frontViewLayer.renderCurrentWall();
                    break;
            }
        });

        this.changeEditorSelectionListener = eventsManager.instance.addListener(Events.CHANGE_EDITOR_SELECTION, (datas: any) => {
            var selection = datas.getUserData().selection;
            PlanManager.getInstance().frontViewLayer.renderCurrentWall();
            if (!selection || selection.length === 0) {
                if (this._entity) FrontViewManager.unselectDecoration(this._entity);
                this.unselectSelectedEntity();
            }
            else {
                this.selectEntity(selection[0]);
                FrontViewManager.selectDecoration(selection[0]);
            }
        });

        // Store return state (construction or decoration)
        this._previousStateWasConstruction = previousStateWasConstruction ?? false;

        PlanManager.getInstance().updateItemsSelected(null, false, false);

        // Coating addition listener, swicth to FrontviewCoating addition state
        this._addCoatingListener = eventsManager.instance.addListener(Events.COATING_DRAG,
            (data: any) => {
                eventsManager.instance.dispatch(Events.CHANGE_STATE, new FrontViewCoating(data.userData.coating, Number(false), this._cursorPosition!));
            }
        );

        // // Decoration addition listener, switch to front view add entity state
        this._addArrangementListener = eventsManager.instance.addListener(Events.ENTITY_EDITION,
            (data: any) => {
                // Drag decoration only if it is an arrangement object and if anchored to a certain height (anchor[1] > 0)
                if (data.userData.entity.entityType === SceneConstants.EntityType.ArrangementObject && data.userData.entity.isAnchorActive && Math.abs(data.userData.entity.anchor[1]) > 0) {
                    eventsManager.instance.dispatch(Events.CHANGE_STATE, new FrontViewAddEntity(data.userData.entity));
                }
            }
        );

        // // Decoration addition listener, switch to front view add entity state
        this._flipViewListener = eventsManager.instance.addListener(Events.FLIP_COCOSFRONT_VIEW,
            (data: any) => {
                PlanManager.getInstance().frontViewLayer.toggleSide();
            }
        );

        this._hideArrangements = eventsManager.instance.addListener(Events.HIDE_ARRANGEMENTS, (event: any) => {
            this.unselectSelectedEntity();
        });
        this.entityEdition = new Listener((data: any) => {
            this.changeToEntityEdition(data.userData.entity);
        });
        eventsManager.instance.addListenerObject(Events.ENTITY_EDITION, this.entityEdition);
    }

    changeToEntityEdition(entity: any) {
        var newState = null;
        if (entity !== null) {
            if (entity.entityType === SceneConstants.EntityType.Joinery) {
                EntityDefaultPropertiesManager.getInstance().convertJoineryToDefaultProperties(entity);
                // entity.length = PlanManager.getInstance().joineriesLength[entity.joineryType];
                PlanManager.getInstance().frontViewLayer.currentWall?.addChild(entity);
                entity.orientation = PlanManager.getInstance().frontViewLayer.isDirectSide;
                newState = new FrontViewAddJoinery(entity, true);
            }
        }
        eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
    }

    getAction(): number {
        return ActionStateEnum.FrontView;
    }

    get isUpdating(): boolean {
        return this._isDragging || this._isResizing;
    }

    isDecorationState(): boolean {
        return (!this._previousStateWasConstruction);
    }

    // The mouse cursor is being moved
    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        super.moveMouseCursor(cursorPosition);
        // Record current position
        this._cursorPosition = math.vec3.clone(cursorPosition);

        if (this._lastPosition === null) {
            return null;
        }

        if (this._entity === null) {
            return null;
        }

        if (math.vec3.distance(this._lastPosition, cursorPosition) > SavaneConstants.PositionTolerance) {
            if (!this._isResizing) {
                this._isDragging = true;
            }
        }

        // If we are dragging an entity
        if (this._isDragging) {
            // Is it a joinery ?
            if (this._entity instanceof Joinery) {
                // Compute delta X
                var deltaX = (cursorPosition[0] - this._lastPosition[0]);

                // Check wall side (direct or indirect)
                if (!PlanManager.getInstance().frontViewLayer.isDirectSide) {
                    // If not direct invert delta X
                    deltaX = -deltaX;
                }

                // Yes compute delta Y
                var deltaY = cursorPosition[2] - this._lastPosition[2];

                // Is the joinery a velux ?
                if (this._entity instanceof Velux) {
                    // Move joinery from wall by deltaY (will move it away or closer from the wall)
                    this._entity.transform.localMatrix[14] = (this._entity as any)._transform.localMatrix[14] + deltaY;
                    // Recompute floor height depending on distance from wall
                    this._entity.updateFromFloorHeight();
                }
                else {
                    // Compute froor height from delta Y
                    this._entity.floorHeight = (this._entity as any)._floorHeight + deltaY;
                }

                // Compute joinery position from begin point (localMatrix[12])
                this._entity.transform.localMatrix[12] = (this._entity as any)._transform.localMatrix[12] + deltaX;

                if (PlanManager.getInstance().snapEnabled) {
                    joineryManager.snap(this._entity);
                }

                // Recompute joinery validity
                if (this._entity.temporary) {
                    this._entity.temporary.recomputeValidity = true;
                }
            }
            else {
                // Normal entity (arrangement)
                var res = math.vec3.create();
                var wall = PlanManager.getInstance().frontViewLayer.currentWall!;

                if (!PlanManager.getInstance().frontViewLayer.isDirectSide) {
                    math.vec3.set(res, (this._entity as any)._transform.globalPosition[0] +
                        (cursorPosition[0] - this._lastPosition[0]) * -wall.wallDirection[0],
                        (this._entity as any)._transform.globalPosition[1] +
                        (cursorPosition[0] - this._lastPosition[0]) * -wall.wallDirection[1],
                        (this._entity as any)._transform.globalPosition[2] + cursorPosition[2] - this._lastPosition[2]);
                }
                else {
                    math.vec3.set(res, (this._entity as any)._transform.globalPosition[0] +
                        (cursorPosition[0] - this._lastPosition[0]) * wall.wallDirection[0],
                        (this._entity as any)._transform.globalPosition[1] +
                        (cursorPosition[0] - this._lastPosition[0]) * wall.wallDirection[1],
                        (this._entity as any)._transform.globalPosition[2] + cursorPosition[2] - this._lastPosition[2]);
                }

                // Assign new position to the object
                this._entity.position = res;
            }
        }
        else {
            // Resizing in height direction
            if ((this._isResizing) === 'height') {
                // Entity floor height
                var entityFloorHeight;
                // Entity height
                var entityHeight;
                // Yes compute delta Y
                var deltaY = cursorPosition[2] - this._lastPosition[2];

                // Special case for velux
                if (this._entity instanceof Velux) {
                    // Get vertical projected height
                    entityHeight = this._entity.getVerticalHeight();
                    // Compute floor height from entity position
                    entityFloorHeight = this._entity.position[2] - (entityHeight / 2);
                }
                else {
                    // Other objects, retrieve floor height and height from object
                    entityFloorHeight = this._entity.floorHeight;
                    entityHeight = (this._entity as Joinery).height;
                }

                // Recompute validity of the object
                if (this._entity.temporary) {
                    this._entity.temporary.recomputeValidity = true;
                }

                // Compute new size
                if (!this._resizingHeight) {
                    if (!(this._entity instanceof Velux)) {
                        if (this._entity.isTechnicalElementEntity()) {
                            var res = (this._entity as any)._transform.globalPosition as math.vec3;
                            res[2] = res[2] + (deltaY / 2);
                            this._entity.transform.globalPosition = res;
                        }
                        else {
                            this._entity.floorHeight = (this._entity as any)._floorHeight + deltaY;
                        }
                    }
                    (this._entity as Joinery).height = (this._entity as any)._height - deltaY;
                }
                else {
                    (this._entity as Joinery).height = (this._entity as any)._height + deltaY;
                }

                if (PlanManager.getInstance().snapEnabled && this._entity.isJoineryEntity()) {
                    joineryManager.snapResize(this._entity as Joinery, this._isResizing, PlanManager.getInstance().frontViewLayer.computeFloorHeight());
                }
            }
            else {
                // Resizing in length direction (i.e. width for front view but length from a rhinov perspective)
                if (this._isResizing === 'length') {
                    var wall = PlanManager.getInstance().frontViewLayer.currentWall!;
                    // Delta length change
                    var delta = (cursorPosition[0] - this._lastPosition[0]);
                    var position;

                    if (this._entity.isJoineryEntity()) {
                        position = this._entity.transform.localPosition[0];
                    }

                    if (this._entity.isTechnicalElementEntity()) {
                        var invertMat = math.mat4.create();
                        var techElementLocalPosition = math.vec3.create();

                        math.mat4.invert(invertMat, wall.globalMatrix);
                        math.vec3.transformMat4(techElementLocalPosition, (this._entity as any)._transform.globalPosition, invertMat);

                        position = techElementLocalPosition[0];
                    }

                    // Check edition direction (direct or indirect)
                    if (!PlanManager.getInstance().frontViewLayer.isDirectSide) {
                        // Invert delta and get position from end of wall
                        delta = -delta;
                        if (this._entity.isJoineryEntity()) {
                            position = wall.length - this._entity.transform.localPosition[0];
                        }
                        if (this._entity.isTechnicalElementEntity()) {
                            var invertMat = math.mat4.create();
                            var techElementLocalPosition = math.vec3.create();

                            math.mat4.invert(invertMat, wall.globalMatrix);
                            math.vec3.transformMat4(techElementLocalPosition, (this._entity as any)._transform.globalPosition, invertMat);

                            position = wall.length - techElementLocalPosition[0];
                        }
                    }

                    // Recompute validity of the object
                    if (this._entity.temporary) {
                        this._entity.temporary.recomputeValidity = true;
                    }
                    // Compute new position
                    if (this._entity instanceof Joinery) {
                        this._entity.transform.localMatrix[12] = (this._entity as any)._transform.localMatrix[12] + (delta / 2);
                    }

                    if (this._entity.isTechnicalElementEntity()) {
                        var invertMat = math.mat4.create();
                        var techElementLocalPosition = math.vec3.create();
                        var finalPosition = math.vec3.create();

                        math.mat4.invert(invertMat, wall.globalMatrix);
                        math.vec3.transformMat4(techElementLocalPosition, (this._entity as any)._transform.globalPosition, invertMat);

                        techElementLocalPosition[0] = techElementLocalPosition[0] + (delta / 2);
                        math.vec3.transformMat4(finalPosition, techElementLocalPosition, wall.globalMatrix);

                        this._entity.position = finalPosition;
                    }

                    var entity = this._entity as TechnicalElement | Joinery;
                    if (!this._resizingRight) {
                        if (PlanManager.getInstance().frontViewLayer.isDirectSide) {
                            entity.length = (entity as any)._length - delta;
                        }
                        else {
                            entity.length = (entity as any)._length + delta;
                        }
                    }
                    else {
                        if (PlanManager.getInstance().frontViewLayer.isDirectSide) {
                            entity.length = (entity as any)._length + delta;
                        }
                        else {
                            entity.length = (entity as any)._length - delta;
                        }
                    }

                    if (PlanManager.getInstance().snapEnabled && this._entity instanceof Joinery) {
                        joineryManager.snapResize(this._entity, this._isResizing, PlanManager.getInstance().frontViewLayer.computeFloorHeight());
                    }

                    if (this._entity instanceof Joinery) {
                        var component = this._entity.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;
                        if (component.joineryTypeId === "5fad1c4a8f1b8b7ad9c2ce98") {
                            (this._entity as Canopy).computeLapeyreCanopyCasement();
                        }
                    }
                }
            }
        }

        // If something edited, redraw front view and update object validity
        if (this._entity !== null) {
            FrontViewManager.updateDecoration(this._entity);
            FrontViewManager.setValidity(this._entity, this._entity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!));

            // Inform WebGL to update this object as it was moved
            eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
                name: Commands.CommandEnum.EditEntityCommand,
                undo: false,
                datas: {
                    id: this._entity.id,
                    type: this._entity.entityType,
                    select: true
                }
            });
        }

        /*if (!this._isDragging || !this._entity.isJoineryEntity()) {
            // Record current position for next loop
            this._lastPosition = math.vec3.clone(cursorPosition);
        }*/

        // We stay in this state
        return null;
    }

    // The mouse button is being released
    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        // Record current position
        this._cursorPosition = math.vec3.clone(cursorPosition);

        var planManager = PlanManager.getInstance();

        // Any edited entity ?
        if (this._entity !== null) {
            // Yes, are we moving or resizing ?
            if (this.isUpdating) {
                // Entity still valid ?
                if (this._entity.isValid(planManager.world.currentScene!.currentFloor!)) {
                    // Yes, are we dragging it ?
                    if (this._isDragging || (this._isResizing !== false)) {
                        // COmmand to set and execute
                        var command;

                        // Is it an joinery ?
                        if (this._entity instanceof Joinery) {
                            command = new Commands.EditJoineryCommand(this._entity);
                        }
                        else {
                            // Move it with an EditEntityCommand
                            command = new Commands.EditEntityCommand(this._entity);
                        }
                        planManager.executeCommand(command);
                    }

                    // Finally redraw the wall and its elements
                    FrontViewManager.updateDecoration(this._entity);
                }
                else {
                    // Invalid entity, do as if we have cancelled the operation
                    this.mouseClickCancelled(cursorPosition);
                }

                // We are no more resizing and dragging
                this._isResizing = false;
                this._isDragging = false;
            }
            else {
                // Nothing done, open tulip
                PlanManager.getInstance().updateItemsSelected([this._entity], true, mouseButton === 2);
            }
        } else {
            PlanManager.getInstance().updateItemsSelected(hoverEntities, true, mouseButton === 2);
        }

        this._lastPosition = null;

        // We stay in this state
        return null;
    }

    // Unselect current selected entity if any
    unselectSelectedEntity() {
        if (this._entity !== null) {
            PlanManager.getInstance().updateItemsSelected(null, false, false);
            FrontViewManager.unselectDecoration(this._entity);
            this._entity = null;
        }
    }

    // Select a new entity
    selectEntity(entity: Entity) {
        PlanManager.getInstance().updateItemsSelected([entity], false, false);
        // Store the entity
        this._entity = entity;
        // Show it as selected
        FrontViewManager.selectDecoration(this._entity);
    }

    _isSelectable(hoverEntities: Entity[]): boolean {
        if (!hoverEntities) {
            return false;
        }

        if (hoverEntities.length !== 1) {
            return false;
        }

        if (!hoverEntities[0]) {
            return(false);
        }

        if (this._previousStateWasConstruction) {
            if (!hoverEntities[0].isJoineryEntity() && !hoverEntities[0].isTechnicalElementEntity()) {
                return(false);
            }
        }
        else {
            if (hoverEntities[0].isJoineryEntity() || hoverEntities[0].isTechnicalElementEntity()) {
                return(false);
            }

            if (hoverEntities[0].isArrangementObjectEntity() && (PlanManager.getInstance()._hideArrangements)) {
                return(false);
            }
        }

        return true;
    }

    // The left mouse button is being pressed
    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (mouseButton === 2) {
            return PlanManager.getInstance().mouseClickCancelled();
        }
        
        this.actionEditEnded();

        // Record current position
        this._cursorPosition = math.vec3.clone(cursorPosition);

        // For the moment we aren't dragging or rezing anything
        this._isDragging = false;
        this._isResizing = false;

        // No entity selected, copy current cursor position into latest cursor position
        if (this._entity !== null) {
            // Get is resizing from FrontViewManager
            this._isResizing = FrontViewManager.toResize(cursorPosition, this._entity);

            // If we are resizing, start temporary
            if (this._isResizing !== false) {
                this._entity.startTemporary();

                var position;
                var wall = PlanManager.getInstance().frontViewLayer.currentWall!;

                if (this._entity.isJoineryEntity()) {
                    position = this._entity.transform.localPosition[0];
                }

                if (this._entity.isTechnicalElementEntity()) {
                    var invertMat = math.mat4.create();
                    var techElementLocalPosition = math.vec3.create();

                    math.mat4.invert(invertMat, wall.globalMatrix);
                    math.vec3.transformMat4(techElementLocalPosition, (this._entity as any)._transform.globalPosition, invertMat);

                    position = techElementLocalPosition[0];
                }

                // Check edition direction (direct or indirect)
                if (!PlanManager.getInstance().frontViewLayer.isDirectSide && position !== undefined) {
                    position = position - wall.length;
                }

                this._resizingRight = position !== undefined && this._cursorPosition[0] > position;
                if (this._entity instanceof Velux) {
                    this._resizingHeight = cursorPosition[2] > this._entity.getVerticalHeight() / 2 + this._entity.position[2] - (this._entity.height / 2);
                }
                else {
                    this._resizingHeight = cursorPosition[2] > (this._entity as Joinery).height / 2 + this._entity.floorHeight;
                }
            }
        }

        if (this._isResizing === false) {
            // Unselect current edited entity
            this.unselectSelectedEntity();

            // If one hovered entity and if it is a joinery
            if (this._isSelectable(hoverEntities) === true) {
                // Select new entity
                this.selectEntity(hoverEntities[0]);
                // Start temporary
                if (this._entity) this._entity.startTemporary();

                // Deactivate anchoring for arrangement objects
                if (!(hoverEntities[0] instanceof Joinery) && !(hoverEntities[0].isTechnicalElementEntity())) {
                    (this._entity as ArrangementObject).isAnchorActive = false;
                }
            }
            else {
                // No hovered entity, check coating area
                var isDirectSide = PlanManager.getInstance().frontViewLayer.isDirectSide;
                var currentWall = PlanManager.getInstance().frontViewLayer.currentWall;

                if (!this._previousStateWasConstruction && currentWall)
                {
                    var areaCoatings = currentWall.getComponents(ComponentConstants.ComponentType.CoatingArea) as CoatingArea[];
                    for (var i = areaCoatings.length - 1; i >= 0; --i) {
                        var pos = math.vec3.clone(cursorPosition);
                        pos[1] = pos[2];
                        pos[2] = 0;
                        if (areaCoatings[i].isDirectSide === isDirectSide && SavaneMath.isInPoly(pos, areaCoatings[i].vertices)) {
                            return new FrontViewCoating(areaCoatings[i], Number(true), this._cursorPosition);
                        }
                    }
                }

                if (this._previousStateWasConstruction && currentWall) {
                    var cutAreas = currentWall.getComponents(ComponentConstants.ComponentType.CutArea) as CutArea[];
                    for (var i = cutAreas.length - 1; i >= 0; --i) {
                        var pos = math.vec3.clone(cursorPosition);
                        pos[1] = pos[2];
                        pos[2] = 0;
                        if (cutAreas[i].isDirectSide === isDirectSide && SavaneMath.isInPoly(pos, cutAreas[i].vertices)) {
                            return new FrontViewCutArea(cutAreas[i], Number(true), this._cursorPosition);
                        }
                    }

                    var addAreas = currentWall.getComponents(ComponentConstants.ComponentType.AddArea) as AddArea[];
                    for (var i = addAreas.length - 1; i >= 0; --i) {
                        var pos = math.vec3.clone(cursorPosition);
                        pos[1] = pos[2];
                        pos[2] = 0;
                        if (addAreas[i].isDirectSide === isDirectSide && SavaneMath.isInPoly(pos, addAreas[i].vertices)) {
                            return new FrontViewAddArea(addAreas[i], Number(true), this._cursorPosition);
                        }
                    }
                }
            }
        }

        if (this._entity !== null) {
            // Keep most recent cursor position
            this._lastPosition = math.vec3.clone(cursorPosition);
        }

        return null;
    }

    // The right mouse button is being pressed (cancel current operation)
    mouseClickCancelled(cursorPosition: math.vec3): ActionState | null {
        // If an entity is being edited
        if (this._entity !== null) {
            // The entity is valid
            FrontViewManager.setValidity(this._entity, true);
            // We end its temporary
            this._entity.endTemporary();
            // We redraw everything
            FrontViewManager.updateDecoration(this._entity);
            // We are no longer dragging or resizing
            this._isDragging = false;
            this._isResizing = false;
            // Nothing selected for last position
            this._lastPosition = null;
        }
        return null;
    }

    // A key is pressed
    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if (keyCode === cc.KEY.shift) {
            this.shiftPressed = true;
        }

        // Escape, return to normal edition mode
        if (keyCode === cc.KEY.escape) {
            // Keep edited wall to select it after leaving
            var editedWall = PlanManager.getInstance().frontViewLayer.currentWall;

            // Entity being edited, end its temprary
            if (this._entity !== null) {
                this._entity.endTemporary();
            }

            // Go back to normal topview edition (construction or decoration)
            PlanManager.getInstance().switchToNormalMode(this._previousStateWasConstruction);
            // Re-select edited wall
            if (editedWall) PlanManager.getInstance().updateItemsSelected([editedWall], false, false);

            // If not construction (i.e. decoration), close webgl front view too
            eventsManager.instance.dispatch(Events.CLOSE_FRONT_VIEW, editedWall);
        }

        if ((keyCode === cc.KEY.up || keyCode === cc.KEY.down || keyCode === cc.KEY.left || keyCode === cc.KEY.right) && this._entity !== null) {
            // Key up pressed
            if (keyCode === cc.KEY.up) {
                // Move it up
                if (this._entity instanceof Velux) {
                    this._entity.transform.localMatrix[13] -= 10;
                    this._entity.updateFloorHeight();
                }
                else {
                    this._entity.floorHeight += 10;
                }
            }

            // Key down pressed
            if (keyCode === cc.KEY.down) {
                // Move it down
                if (this._entity instanceof Velux) {
                    this._entity.transform.localMatrix[13] += 10;
                    this._entity.updateFloorHeight();
                }
                else {
                    this._entity.floorHeight -= 10;
                }
            }

            // Key left pressed
            if (keyCode === cc.KEY.left) {
                // Move it left
                var d = math.vec3.fromValues(this._entity.transform.localMatrix[0], this._entity.transform.localMatrix[1], this._entity.transform.localMatrix[2]);
                this._entity.transform.localMatrix[12] += d[0] * 10;
                this._entity.transform.localMatrix[13] += d[1] * 10;
                this._entity.transform.localMatrix[14] += d[2] * 10;
            }

            // Key right pressed
            if (keyCode === cc.KEY.right) {
                // Move it right
                var d = math.vec3.fromValues(this._entity.transform.localMatrix[0], this._entity.transform.localMatrix[1], this._entity.transform.localMatrix[2]);
                this._entity.transform.localMatrix[12] -= d[0] * 10;
                this._entity.transform.localMatrix[13] -= d[1] * 10;
                this._entity.transform.localMatrix[14] -= d[2] * 10;
            }

            // Redraw eveything
            FrontViewManager.updateDecoration(this._entity);
            // Inform WebGL to update this object as it was moved
            eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
                name: Commands.CommandEnum.EditEntityCommand,
                undo: false,
                datas: {
                    id: this._entity.id,
                    type: this._entity.entityType,
                    select: true
                }
            });
            this._entity.endTemporary();
        }

        // Page up and page down, flip the wall edited side
        if ((keyCode === 33) || (keyCode === 34)) {
            PlanManager.getInstance().frontViewLayer.toggleSide();
        }

        // Delete key pressed
        if (keyCode == cc.KEY.Delete || keyCode == cc.KEY.backspace) {
            // If an entity is selected
            if (this._entity !== null) {
                // Delete the object from the front view
                FrontViewManager.deleteDeco(this._entity);
                // Delete the entity depending on its type
                if (this._entity.isJoineryEntity()) {
                    PlanManager.getInstance().executeCommand(new Commands.DeleteJoineriesCommand([this._entity as Joinery]));
                }
                else {
                    PlanManager.getInstance().executeCommand(new Commands.DeleteEntityCommand(this._entity, false));
                }
                // No entity edited anymore now
                PlanManager.getInstance().updateItemsSelected(null);
                this._entity = null;
            }
        }

        if (keyCode == cc.KEY.c && this._previousStateWasConstruction) {
            eventsManager.instance.dispatch(Events.CHANGE_STATE, new FrontViewCutArea(undefined as any, Number(false), this._cursorPosition!));
        }

        if (keyCode == cc.KEY.a && this._previousStateWasConstruction) {
            eventsManager.instance.dispatch(Events.CHANGE_STATE, new FrontViewAddArea(undefined as any, Number(false), this._cursorPosition!));
        }

        if (keyCode === cc.KEY.n) {
            // If an entity is selected
            if (this._entity !== null) {
                if (this._entity instanceof Joinery) {
                    var positionToTest = math.vec3.create();
                    math.vec3.copy(positionToTest, this._entity.position);
                    if (this.shiftPressed) {
                        positionToTest[2] = this._entity.floorHeight + this._entity.height + (this._entity.wall.height - (this._entity.floorHeight + this._entity.height)) / 2;
                    }
                    else {
                        positionToTest[2] = this._entity.floorHeight / 2;
                    }
                    var joinery = joineryManager.getJoineryAtPositionWithType(positionToTest, SavaneConstants.PositionTolerance * 3, PlanManager.getInstance().world.currentScene!.currentFloor!, this._entity.id, SceneConstants.JoineryType.niche);

                    if (!joinery) {
                        var niche = EntityFactory.getInstance().createJoinery(math.vec3.create(), SceneConstants.JoineryType.niche, this._entity.length);
                        niche.parent = this._entity.parent;
                        math.mat4.copy(niche.transform.localMatrix, this._entity.transform.localMatrix);
                        if (this.shiftPressed) {
                            niche.height = this._entity.wall.height - (this._entity.floorHeight + this._entity.height);
                            niche.floorHeight = this._entity.floorHeight + this._entity.height;
                        }
                        else {
                            niche.height = this._entity.floorHeight;
                            niche.floorHeight = 0;
                        }
                        niche.orientation = !this._entity.orientation;
                        if (this._entity.wallInstallType === -1) {
                            niche.orientation = !niche.orientation;
                        }
                        niche.wallInstallType = 1;
                        (niche as Niche).thickness = this._entity.wall.thickness / 2;
                        if (niche.height > 0) {
                            niche.height += 10;
                            if (this.shiftPressed) {
                                niche.floorHeight -= 10;
                            }
                            PlanManager.getInstance().executeCommand(new Commands.AddJoineryCommand(niche));
                            FrontViewManager.updateDecoration(niche);
                        }

                        this.selectEntity(this._entity);
                    }
                }
            }
        }

        return null;
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean): ActionState | null {
        if (keyCode === cc.KEY.shift) {
            this.shiftPressed = false;
        }
        return null;
    }

    actionDelete() {
        var planManager = PlanManager.getInstance();

        FrontViewManager.deleteDeco(planManager.selectedEntities[0]);

        if (planManager.selectedEntities.length !== 0 && planManager.selectedEntities[0].isJoineryEntity()) {
            GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint');
            GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint2');
            planManager.executeCommand(new Commands.DeleteJoineriesCommand(planManager.selectedEntities as Joinery[]));
        }

        if (planManager.selectedEntities.length !== 0 && (planManager.selectedEntities[0].isArrangementObjectEntity() || planManager.selectedEntities[0].isArrangementGroupEntity() || planManager.selectedEntities[0].isTechnicalElementEntity())) {
            planManager.executeCommand(new Commands.DeleteEntitiesCommand(planManager.selectedEntities));
        }

        planManager.updateItemsSelected(null);
        this._entity = null;
    }

    actionUngroup(): ActionState | null {
        var planManager = PlanManager.getInstance();
        if (planManager.selectedEntities.length === 1 && planManager.selectedEntities[0].isArrangementGroupEntity()) {
            PlanManager.getInstance().executeCommand(new Commands.DeleteGroupCommand(planManager.selectedEntities[0] as ArrangementGroup));
        }
        else {
            if (planManager.selectedEntities.length === 1 && planManager.selectedEntities[0].isArrangementObjectEntity()) {
                var children = planManager.selectedEntities[0].getChildren([SceneConstants.EntityType.ArrangementGroup, SceneConstants.EntityType.ArrangementObject], null);
                var childrenToUngroup = [];

                for (var i = 0; i < children.length; i++) {
                    if (!children[i].isGhost()) {
                        childrenToUngroup.push(children[i]);
                    }
                }

                PlanManager.getInstance().executeCommand(new Commands.EntitiesLeaveGroupCommand(childrenToUngroup, planManager.selectedEntities[0]));
            }
        }
        return null;
    }

    actionLeaveGroup(params: any): ActionState | null {
        var planManager = PlanManager.getInstance();

        var entity;
        if (params) {
            entity = params.getUserData();
        }
        if (!entity) {
            entity = planManager.selectedEntities[0];
        }
        if ((planManager.selectedEntities.length === 1) && (entity.parent.isArrangementGroupEntity()) && (entity.parent.iArrangements.length > 2)) {
            PlanManager.getInstance().executeCommand(new Commands.LeaveGroupCommand(entity));
        }
        else {
            if ((planManager.selectedEntities.length === 1) && (entity.parent.isArrangementObjectEntity())) {
                PlanManager.getInstance().executeCommand(new Commands.LeaveGroupCommand(entity));
            }
            else {
                if ((entity.parent.isArrangementGroupEntity()) && (entity.parent.iArrangements.length <= 2)) {
                    PlanManager.getInstance().executeCommand(new Commands.DeleteGroupCommand(entity.parent));
                }
            }
        }
        return null;
    }

    startEdit() {
        if (this._entity !== null) {
            this._entity.startTemporary();
        }
    }

    plusOrLessClickedHandler(event: Event) {
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        if (this._entity != null) {
            this.capValue(event.getUserData().editedProperty, event.getUserData().value);

            this.actionEditEntity(this._entity);
        }
        this.hasBeenEdited = true;
    }

    sliderButtonHandler(event: Event) {
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        if (this._entity != null) {
            var value = event.getUserData().value;
            if (event.getUserData().editedProperty === GUIConstants.OPENING_MODE) {
                value = value ? SceneConstants.OpeningMode.mode_slide : SceneConstants.OpeningMode.mode_default;
                if (value === SceneConstants.OpeningMode.mode_default) {
                    if ((this._entity as any)[GUIConstants.NB_DOORS] > SceneConstants.MaxDoorJoineryDefault) {
                        (this._entity as any)[GUIConstants.NB_DOORS] = SceneConstants.MaxDoorJoineryDefault;
                    }
                }
            } else if (event.getUserData().editedProperty === GUIConstants.SHUTTER) {
                var rollingShutter = null;
                for (var i = 0; i < this._entity.children.length; i++) {
                    if (this._entity.children[i].entityType === SceneConstants.EntityType.TechnicalElement &&
                        (this._entity.children[i] as TechnicalElement).objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                        (this._entity.children[i] as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                        rollingShutter = this._entity.children[i];
                    }
                }
                if (event.getUserData().value === false) {
                    if (rollingShutter !== null) {
                        EntityManager.getInstance().removeEntity(rollingShutter);
                        this._entity.deleteChild(rollingShutter.id);

                    }
                } else {
                    var entity = this._entity as Joinery;
                    if (rollingShutter === null) {
                        rollingShutter = EntityFactory.getInstance().createTechnicalElement(SceneConstants.TechnicalElementType.ceilingBox,
                            (this._entity as TechnicalElement).length, 200, 200, '0', '');
                        this._entity.addChild(rollingShutter);
                        EntityManager.getInstance().addEntity(rollingShutter);
                    }
                    var position = math.vec3.create();
                    //                    if (event.getUserData().value < 0) {
                    // TODO finish debugging this
                    //                        console.log("1");
                    if (entity.orientation) {
                        math.vec3.set(position, 0, -(entity.parent as Wall).thickness / 2, entity.height + this._entity.floorHeight);
                    }
                    else {
                        math.vec3.set(position, 0, (entity.parent as Wall).thickness / 2, entity.height + this._entity.floorHeight);
                    }
                    if (entity.transom) {
                        position[2] = entity.transomHeight;
                    }
                    rollingShutter.transform.localPosition = position;
                }
            } else if (event.getUserData().editedProperty === 'handleSide'
                && ((this._entity as Door).nbDoors === 1 || (this._entity as Window).nbCasement === 1)) {
                value = !value ? SceneConstants.HandleSide.handle_left : SceneConstants.HandleSide.handle_right;

            } else if (event.getUserData().editedProperty === 'shapeType') {
                value = value ? 1 : 0;
            }

            // Normal property field of an entity
            if ((this._entity as any)[event.getUserData().editedProperty] !== undefined) {
                (this._entity as any)[event.getUserData().editedProperty] = value;
            }

            // Post update rolling sutter
            if (event.getUserData().editedProperty === 'orientation') {
                for (var j = 0; j < this._entity.children.length; j++) {
                    var joinChild = this._entity.children[j];

                    if (joinChild.entityType === SceneConstants.EntityType.TechnicalElement &&
                        (joinChild as TechnicalElement).objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                        (joinChild as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                        (joinChild as CeilingBox).length = (this._entity as Joinery | TechnicalElement).length;

                        var position = math.vec3.create();

                        if ((this._entity as Joinery).orientation) {
                            math.vec3.set(position, 0, -(this._entity.parent as Wall).thickness / 2, (this._entity as Joinery).height + this._entity.floorHeight);
                        } else {
                            math.vec3.set(position, 0, (this._entity.parent as Wall).thickness / 2, (this._entity as Joinery).height + this._entity.floorHeight);
                        }
                        joinChild.transform.localPosition = position;
                    }
                }
            }

            this.actionEditEntity(this._entity);
        }
        this.hasBeenEdited = true;
    }

    capValue(property: string, value: number): number {
        return this._entity!.addToCappedProperty(property, value);
    }

    actionEditEnded() {
        var planManager = PlanManager.getInstance();
        if (this.hasBeenEdited) {
            if (this._entity != null) {
                if (!this._entity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
                    this._entity.endTemporary();
                }
                else {
                    if (this._entity instanceof Joinery) {
                        planManager.executeCommand(new Commands.EditJoineryCommand(this._entity));
                        EntityDefaultPropertiesManager.getInstance().setJoineryDefaultProperties(this._entity);
                    }
                    else if (this._entity.isTechnicalElementEntity()) {
                        planManager.executeCommand(new Commands.EditTechnicalElementCommand(this._entity as TechnicalElement));
                    }
                    else if (this._entity instanceof ArrangementObject) {
                        planManager.executeCommand(new Commands.EditEntityCommand(this._entity));
                    }
                }
            }
            this.hasBeenEdited = false;
        }

        if (this._entity !== null) {
            this._entity.endTemporary();
            FrontViewManager.updateDecoration(this._entity);
        }
    }

    actionTextFieldEditEnded(property: string, value: number, obj: Entity, isLast?: boolean) {
        this._entity = obj;
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        if (this._entity != null) {
            var isNotCm = property === GUIConstants.NB_DOORS
                || property === GUIConstants.NB_CASEMENTS;

            // Normal property field of an entity
            if ((this._entity as any)[property] !== undefined) {
                this.capValue(property, isNotCm ? value / 10 - (this._entity as any)[property] : value - (this._entity as any)[property]);
            }

            this.actionEditEntity(this._entity);
        }
        this.hasBeenEdited = true;
    }

    actionEditEntity(selected: Entity) {
        var i, j;
        var joinChild, position;
        var valid = selected.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);

        //TODO : move this at the right pos (could be refacto considering there is 3 time the "set local position" block)
        // Twice here and one in sliderButtonHandler method  of file IdleConstruction
        if (!valid) {
            if (selected instanceof Wall) {
                for (i = 0; i < selected.children.length; i++) {
                    var join = selected.children[i] as Joinery;
                    if (join.entityType === SceneConstants.EntityType.Joinery) {
                        for (j = 0; j < join.children.length; j++) {
                            joinChild = join.children[j];
                            if (joinChild.entityType === SceneConstants.EntityType.TechnicalElement &&
                                (joinChild as TechnicalElement).objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                                (joinChild as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {

                                (joinChild as TechnicalElement).length = join.length;
                                position = math.vec3.create();
                                //if (joinChild.transform.localPosition[1] < 0) {
                                if (join.orientation) {
                                    math.vec3.set(position, 0, -selected.thickness / 2, join.height + join.floorHeight);
                                } else {
                                    math.vec3.set(position, 0, selected.thickness / 2, join.height + join.floorHeight);
                                }
                                if (join.transom) {
                                    position[2] = join.transomHeight;
                                }
                                joinChild.transform.localPosition = position;
                            }
                        }
                    }
                }
            } else if (selected instanceof Joinery) {
                for (j = 0; j < selected.children.length; j++) {
                    joinChild = selected.children[j];
                    if (joinChild.entityType === SceneConstants.EntityType.TechnicalElement &&
                        (joinChild as TechnicalElement).objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                        (joinChild as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                        (joinChild as TechnicalElement).length = selected.length;
                        position = math.vec3.create();
                        if (joinChild.transform.localPosition[1] < 0) {
                            math.vec3.set(position, 0, -(selected.parent as Wall).thickness / 2, selected.height + selected.floorHeight);
                        } else {
                            math.vec3.set(position, 0, (selected.parent as Wall).thickness / 2, selected.height + selected.floorHeight);
                        }
                        if (selected.transom) {
                            position[2] = selected.transomHeight;
                        }
                        joinChild.transform.localPosition = position;
                    }
                }
            }
            else if (selected instanceof ArrangementObject || selected instanceof ArrangementGroup) {
                var currentFloor = PlanManager.getInstance().world.currentScene!.currentFloor!;
                selected.updateFloorHeightFromAnchor(roomManager.getRoomAtPosition(selected.position, currentFloor)!, currentFloor);

                PlanManager.getInstance().executeCommand(new Commands.EditEntityCommand(selected));
            }
        }
        if (selected instanceof Wall) {
            var currentFloor = PlanManager.getInstance().world.currentScene!.currentFloor!;
            var beginWalls = wallManager.getWallsAtCorner(selected.begin, currentFloor, SavaneConstants.PositionTolerance);
            if (beginWalls != null) {
                for (i = 0; i < beginWalls.length; ++i) {
                    GameObjectManager.drawWall(beginWalls[i], undefined, false);
                }
            }
            var endWalls = wallManager.getWallsAtCorner(selected.end, currentFloor, SavaneConstants.PositionTolerance);
            if (endWalls != null) {
                for (i = 0; i < endWalls.length; ++i) {
                    GameObjectManager.drawWall(endWalls[i], undefined, false);
                }
            }
            GameObjectManager.drawWall(selected, undefined, true);
        } else {
            var node = EntityManager.getInstance().getNode(selected);
            if (node !== null) {
                node.update(undefined);
            }
        }

        if (selected !== null) {
            FrontViewManager.updateDecoration(selected);
        }

        eventsManager.instance.dispatch(Events.ACTIONS_COUNT_CHANGE);
        eventsManager.instance.dispatch(Events.SHOW_WALL_PROPERTIES, { obj: selected });
    }

    // State termination, free listeners created in the class creation
    dispose() {
        this.actionEditEnded();

        if (this._hideArrangements) eventsManager.instance.removeListener(this._hideArrangements);
        if (this.changeEditorSelectionListener) eventsManager.instance.removeListener(this.changeEditorSelectionListener);
        if (this.actionCountChange) eventsManager.instance.removeListener(this.actionCountChange);
        if (this._addArrangementListener) eventsManager.instance.removeListener(this._addArrangementListener);
        if (this._addCoatingListener) eventsManager.instance.removeListener(this._addCoatingListener);
        if (this.plusListener) eventsManager.instance.removeListener(this.plusListener);
        if (this.lessListener) eventsManager.instance.removeListener(this.lessListener);
        if (this.textFieldListener) eventsManager.instance.removeListener(this.textFieldListener);
        if (this.ungroupEntitiesListener) eventsManager.instance.removeListener(this.ungroupEntitiesListener);
        if (this.ungroupEntityListener) eventsManager.instance.removeListener(this.ungroupEntityListener);
        if (this.deleteListener) eventsManager.instance.removeListener(this.deleteListener);
        if (this.unselectListener) eventsManager.instance.removeListener(this.unselectListener);
        if (this.entityEdition) eventsManager.instance.removeListener(this.entityEdition);
    }
}